import React from "react";
import Cookie from "browser-cookies";

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.manageCompare = this.manageCompare.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
    this.state = {
      checked: false
    };
  }

  componentDidMount() {
    this.checkStatus();
    this.setState({
      subscriber: PubSub.subscribe("COMPARE_UPDATED", (msg, data) => {
        this.checkStatus();
      })
    });
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.state.subscriber);
  }

  checkStatus() {
    const cookie_key = "engex_product_compare";
    let current_compare_products = JSON.parse(Cookie.get(cookie_key));
    if (_.includes(current_compare_products, this.props.data.catalogue)) {
      this.setState({
        checked: true
      });
    } else {
      this.setState({
        checked: false
      });
    }
  }

  manageCompare() {
    const MAX_COMPARE = 3;
    const cookie_key = "engex_product_compare";
    let current_compare_products = JSON.parse(Cookie.get(cookie_key));

    if (current_compare_products === null) {
      current_compare_products = [];
    }

    if (_.includes(current_compare_products, this.props.data.catalogue)) {
      _.remove(current_compare_products, f => f === this.props.data.catalogue);
      this.setState({ checked: false });
    } else {
      if (current_compare_products.length === MAX_COMPARE) {
        current_compare_products.unshift(this.props.data.catalogue);
        current_compare_products.pop();
        this.setState({ checked: true });
      } else {
        current_compare_products.push(this.props.data.catalogue);
        this.setState({ checked: true });
      }
    }
    Cookie.set(cookie_key, JSON.stringify(current_compare_products));
    PubSub.publish("COMPARE_UPDATED");
  }

  render() {
    let checked =
      this.state.checked === true ? (
        <i className="material-icons">&#xE837;</i>
      ) : (
        <i className="material-icons">&#xE836;</i>
      );
    return (
      <div className={`product ${this.props.data.category}`}>
        <a href={this.props.data.url}>
          <img src={this.props.data.image.replace("medium", "small")} className="img-fluid" />
        </a>
        <div className="product-info">
          <a href={this.props.data.url}>
            <h6 className="product-info__title">{this.props.data.description_short}</h6>
          </a>
          <div>
            <div className="product-info__codes">
              <div className="product-code">
                <span>Part Code:</span> {this.props.data.catalogue}
              </div>
              <div className="product-code">
                <span>Stock Code:</span> {this.props.data.stock_code}
              </div>
            </div>
            <div className="product-info__buttons">
              <div className="product-info__compare-btn" onClick={this.manageCompare}>
                {checked} Compare
              </div>
              <a className="product-info__add-btn" href={this.props.data.url}>View</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { Product as default };
